module.exports = __webpack_public_path__ + "img/SE5569622441.c9db4355.png";